module.exports = __webpack_public_path__ + "media/images/lilica/lilica2-e570f70423a671fb26f3c2650621b8a3.png";